import { MaterialUnit } from '@/app/types/material-units';
import { ApiClient, Paginated, PaginationParams } from './client';

/**
 * API client for material units-related endpoints
 */
export class MaterialUnitsClient extends ApiClient {
  /**
   * Fetch all material units
   * @throws {Error} If the API request fails
   */
  async getAll(params?: PaginationParams) {
    return this._get<Paginated<MaterialUnit>>('material-units/', params);
  }
}
